import { Controller } from "@hotwired/stimulus"
import type { TurboSubmitStartEvent } from "@hotwired/turbo"
import { t } from "../lib/i18n"

export default class extends Controller<HTMLFormElement> {
  private form: HTMLFormElement

  connect() {
    if (this.element.tagName === "FORM") {
      this.form = this.element as HTMLFormElement
    } else if (this.element.form) {
      this.form = this.element.form
    } else {
      throw new Error("turbo-form controller can only be used with forms and form inputs")
    }
  }

  submit() {
    this.form.classList.add("was-validated")

    if (!this.form.checkValidity()) {
      const errorMessage =
        this.element.getAttribute("data-validation-error") || t("form_validation_error")
      alert(errorMessage)
      return
    }

    const formData = new FormData(this.form)

    fetch(this.form.action, {
      method: this.form.method.toUpperCase(),
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          alert(t("form_submission_failed") || "Something went wrong.")
        }
      })
      .catch((error) => {
        console.error("Submission error:", error)
        alert(t("form_submission_failed") || "Network error.")
      })
  }

  validate(event: TurboSubmitStartEvent) {
    const submitter = event.detail.formSubmission.submitter
    if (submitter?.hasAttribute("data-skip-validation")) {
      return
    }

    this.element.classList.add("was-validated")
    if (!this.element.checkValidity()) {
      event.detail.formSubmission.stop()
      const errorMessage =
        this.element.getAttribute("data-validation-error") || t("form_validation_error")
      alert(errorMessage)
    }
  }
}
